import React from 'react';

/**
 * BBB Dynamic Seal for Alert1 Medical Alert Systems (BBB ID 235969452).
 *
 * BBB requires the dynamic seal (served from their seal host) for website use;
 * it links to the live profile and the "rating" variant renders the current
 * letter grade and date server-side, so it never goes stale.
 */

export const BBB_PROFILE_URL =
  'https://www.bbb.org/us/pa/williamsport/profile/medical-alert-systems/alert1-medical-alert-systems-0241-235969452';

const BBB_SEAL_CLICK_URL = `${BBB_PROFILE_URL}/#sealclick`;
const BBB_SEAL_HOST = 'https://seal-dc-easternpa.bbb.org/seals';
const BBB_ID = '235969452';

type SealVariant = 'slim' | 'horizontal' | 'horizontal-white' | 'rating' | 'badge';

const SEALS: Record<SealVariant, { file: string; width: number; height: number }> = {
  /** 200x42 - compact strip, fits footers and nav bars. */
  slim: { file: 'blue-seal-200-42-bbb', width: 200, height: 42 },
  /** 250x52 - standard horizontal seal. */
  horizontal: { file: 'blue-seal-250-52-bbb', width: 250, height: 52 },
  /** 250x52 - white text for dark backgrounds. */
  'horizontal-white': { file: 'blue-seal-250-52-whitetxt-bbb', width: 250, height: 52 },
  /** 280x80 - includes live "BBB Rating: A+" and as-of date. */
  rating: { file: 'blue-seal-280-80-bbb', width: 280, height: 80 },
  /** 160x82 - stacked badge for sidebars and cards. */
  badge: { file: 'blue-seal-160-82-bbb', width: 160, height: 82 },
};

interface BBBSealProps {
  variant?: SealVariant;
  className?: string;
}

const BBBSeal: React.FC<BBBSealProps> = ({ variant = 'horizontal', className }) => {
  const seal = SEALS[variant];
  return (
    <a
      href={BBB_SEAL_CLICK_URL}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className={className ? `bbb-seal ${className}` : 'bbb-seal'}
      aria-label="Alert1 Medical Alert Systems BBB Business Review (opens in a new tab)"
    >
      <img
        src={`${BBB_SEAL_HOST}/${seal.file}-${BBB_ID}.png`}
        width={seal.width}
        height={seal.height}
        style={{ border: 0 }}
        alt="Alert1 Medical Alert Systems BBB Business Review"
        loading="lazy"
      />
    </a>
  );
};

export default BBBSeal;
